import { ClampedText } from "../ClampedText";

/** Put the reason and the concrete change in the same place on both review cards. */
export function ReviewSummary({
  summary,
  change,
}: {
  readonly summary: string;
  readonly change?: string | undefined;
}) {
  return (
    <div data-review-summary className="mt-1.5 space-y-2 text-sm leading-6">
      <ClampedText className="text-muted-foreground">{summary}</ClampedText>
      {change && change !== summary ? (
        <div className="border-l-2 border-border/70 pl-3">
          <ClampedText className="text-foreground">
            <span className="sr-only">Change needed: </span>
            {change}
          </ClampedText>
        </div>
      ) : null}
    </div>
  );
}
